import { identityCardType } from 'json/customer-options'
// 商品订单状态
export let orderStatus = [
  {
    label: '待支付',
    value: 'WAITING_FOR_PAYMENT'
  },
  {
    label: '已支付',
    value: 'PAID'
  },
  //   {
  //     label: '已发货',
  //     value: 'SHIPPED'
  //   },
  //   {
  //     label: '已收货',
  //     value: 'RECEIVED'
  //   },
  {
    label: '已关闭',
    value: 'CLOSED'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  }
]
// 商品订单状态
export let newOrderStatus = [
  {
    label: '待支付',
    value: 'WAITING_FOR_PAYMENT'
  },
  {
    label: '支付中',
    value: 'PAYING'
  },
  {
    label: '已支付',
    value: 'PAID'
  },
  //   {
  //     label: '已发货',
  //     value: 'SHIPPED'
  //   },
  //   {
  //     label: '已收货',
  //     value: 'RECEIVED'
  //   },
  {
    label: '已关闭',
    value: 'CLOSED'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  }
]
// 退款方式
export let refundmentType = [
  {
    label: '仅退款',
    value: 'MONEY'
  },
  {
    label: '退款退货',
    value: 'MONEY_AND_GOODS'
  }
]
// 退款状态
export let orderRefundStatus = [
  {
    label: '待审核',
    value: 'SUBMITTED'
  },
  {
    label: '退款已审批',
    value: 'REFUND_APPROVED'
  },
  {
    label: '退款已驳回',
    value: 'REFUND_REJECTED'
  },
  {
    label: '退款失败',
    value: 'REFUND_FAILED'
  },
  {
    label: '退款成功',
    value: 'REFUND_COMPLETED'
  },
  {
    label: '取消退款',
    value: 'REFUND_CANCELLED'
  },
  {
    label: '退款超时',
    value: 'REFUND_TIMEOUT'
  }
]
// 退款退货的退款原因
export let refundReturn = [
  {
    label: '质量、规格问题',
    value: 'QUALITY_AND_SPECIFICATION'
  },
  {
    label: '客服发错货',
    value: 'DELIVERY_ERROR'
  },
  {
    label: '收到货物破损',
    value: 'GOODS_DAMAGED'
  }
]
// 仅退款的退款原因
export let onlyRefundReason = [
  {
    label: '快递未送到货',
    value: 'EXPRESS_NOT_ARRIVE'
  },
  {
    label: '未发货',
    value: 'UNSHIPPED'
  }
]
// 收货状态
export let sendGoodsStutes = [
  {
    label: '已收到货',
    value: 'RECEIVED'
  },
  {
    label: '未收到货',
    value: 'NOT_RECEIVED'
  },
  {
    label: '拒收',
    value: 'REFUSED'
  }
]
// 商品订单支付方式枚举
export let channelOptions = [
  {
    label: '未指定任何渠道',
    value: 'none'
  },
  {
    label: '模拟支付',
    value: 'mock'
  },
  {
    label: '虚拟币支付',
    value: 'wallet'
  },
  {
    label: '账户余额支付',
    value: 'mymoney'
  },
  {
    label: '支付宝App支付',
    value: 'alipay'
  },
  {
    label: '支付宝手机网站支付',
    value: 'alipay_wap'
  },
  {
    label: '支付宝当面付',
    value: 'alipay_qr'
  },
  {
    label: '支付宝条码支付',
    value: 'alipay_scan'
  },
  {
    label: '支付宝电脑网站支付',
    value: 'alipay_pc_direct'
  },
  {
    label: '微信App支付',
    value: 'alipay_pc_direct'
  },
  {
    label: '微信公众号支付',
    value: 'wx_pub'
  },
  {
    label: '微信 H5 支付',
    value: 'wx_wap'
  },
  {
    label: '微信小程序支付',
    value: 'wx_lite'
  },
  {
    label: '微信公众号扫码支付',
    value: 'wx_pub_qr'
  },
  {
    label: '微信公众号刷卡支付',
    value: 'wx_pub_scan'
  }
]
// 退款渠道
export let refundChannels = [
  {
    label: '原路返回',
    value: 'RETURN_PLACED_WAY'
  },
  {
    label: '返至"我的钱包"余额',
    value: 'BALANCE_WALLET'
  }
]
// 样本板类型
export let plateType = [
  {
    label: '客户样本板',
    value: 'CUSTOM_SAMPLE_PLATE'
  },
  {
    label: 'PCR板',
    value: 'PCR_PLATE'
  },
  {
    label: '深孔板',
    value: 'DEEP_WELL_PLATE'
  },
  {
    label: '酶标板',
    value: 'ELISA_PLATE'
  },
  {
    label: '点样板',
    value: 'SAMPLE_PLATE'
  },
  {
    label: '杂交板/芯片',
    value: 'HYBRIDIZATION_SAMPLE_PLATE'
  }
]
// 样本类型枚举
export let sampleType = [
  // {
  //   label: '脐带',
  //   value: 'UMBILICAL_CORD'
  // },
  // {
  //   label: '脐血',
  //   value: 'UMBILICAL_CORD_BLOOD'
  // },
  {
    label: '口腔拭子',
    value: 'ORAL_SWAB'
  },
  {
    label: '唾液',
    value: 'SALIVA'
  },
  {
    label: '血卡',
    value: 'BLOOD_CARD'
  },
  {
    label: '植物样本',
    value: 'PLANT_LEAF'
  },
  {
    label: '新鲜动物组织',
    value: 'FRESH_ANIMAL_TISSUE'
  },
  {
    label: '固定后动物组织',
    value: 'FIXED_ANIMAL_TISSUE'
  },
  {
    label: 'FFPE样本',
    value: 'FFPE'
  },
  {
    label: '毛发',
    value: 'HAIR'
  },
  {
    label: 'DNA',
    value: 'DNA'
  },
  {
    label: '全血（静脉血）',
    value: 'VENOUS_BLOOD'
  },
  {
    label: '血浆',
    value: 'PLASMA'
  },
  {
    label: '切片类型',
    value: 'SECTION'
  },
  {
    label: '其他',
    value: 'OTHER'
  }
]
export let ucasSampleType = [
  {
    label: 'DNA',
    value: 'DNA'
  },
  {
    label: '唾液',
    value: 'SALIVA'
  },
  {
    label: '口腔拭子',
    value: 'ORAL_SWAB'
  },
  {
    label: '血液',
    value: 'VENOUS_BLOOD'
  },
  {
    label: '血浆',
    value: 'PLASMA'
  },
  {
    label: '血卡',
    value: 'BLOOD_CARD'
  },
  {
    label: '毛发',
    value: 'HAIR'
  },
  {
    label: '其他',
    value: 'OTHER'
  }
]
// 发票类型
export let invoiceTypes = [
  {
    label: '增值税普通发票',
    value: 'VAT'
  },
  {
    label: '增值税专用发票',
    value: 'VATS'
  }
]
// 发票形式
export let invoiceForms = [
  {
    label: '电子发票',
    value: 'ELECTRONIC'
  },
  {
    label: '纸质发票',
    value: 'PAPER'
  }
]
// 发票状态
export let invoiceStates = [
  {
    label: '待开票',
    value: 'PENDING'
  },
  {
    label: '发票已生效',
    value: 'VALID'
  },
  {
    label: '发票已作废',
    value: 'CANCELLED'
  },
  {
    label: '发票已重开',
    value: 'REAPPLIED'
  },
  {
    label: '开票失败',
    value: 'FAILURE'
  }
]
// 证件类型枚举
export let identityCardTypes = identityCardType
export let refundModes = [
  {
    label: '系统退款',
    value: 'AUTO'
  },
  {
    label: '线下退款',
    value: 'MANUAL'
  }
]

export let gender = [
  {
    label: '仅适用男性',
    value: 'M'
  },
  {
    label: '仅适用女性',
    value: 'F'
  },
  {
    label: '适用男性及女性',
    value: 'MF'
  }
]
